import { useTranslation } from 'react-i18next';
import { useThemeContext } from '@utils/hooks/use-theme-context';
import { X, AlertTriangle } from 'lucide-react';
import Button from '@components/atoms/ui-kit/button';
import { AdminPlan } from '@utils/types/admin';

type PlanDeleteModalProps = {
  plan: AdminPlan;
  isLoading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function PlanDeleteModal({
  plan,
  isLoading,
  onConfirm,
  onCancel
}: PlanDeleteModalProps) {
  const { t } = useTranslation();
  const { getColour } = useThemeContext();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={onCancel} />
      <div
        className="relative w-full max-w-md rounded-2xl shadow-xl p-6"
        style={{ backgroundColor: getColour('baseLayer') }}
      >
        <button
          onClick={onCancel}
          className="absolute top-4 right-4 p-1 rounded-2xl hover:bg-black/5"
        >
          <X className="h-4 w-4" style={{ color: getColour('inactiveText') }} />
        </button>

        <div className="flex items-center gap-3 mb-4">
          {}
          <div className="h-10 w-10 rounded-full flex items-center justify-center bg-red-500/10">
            {}
            <AlertTriangle className="h-5 w-5 text-red-500" />
          </div>
          <h3
            className="text-lg font-semibold"
            style={{ color: getColour('normalText') }}
          >
            {t('delete-plan')}
          </h3>
        </div>

        <p
          className="text-sm mb-6"
          style={{ color: getColour('inactiveText') }}
        >
          {t('delete-plan-confirmation', { sku: plan.sku })}
        </p>

        <div className="flex justify-end gap-3">
          <Button
            onClick={onCancel}
            variant="gray"
            size="small"
            label={t('cancel')}
          />
          <Button
            onClick={onConfirm}
            disabled={isLoading}
            loading={isLoading}
            variant="danger"
            size="small"
            label={t('delete')}
          />
        </div>
      </div>
    </div>
  );
}
